// Function to fetch products data

import { getToken } from "./authHelper";

export const fetchProducts = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_products`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    const productDetails = await data.results.product_details;
    return productDetails;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const fetchUsers = async (
  limit,
  offset,
  searchEmail,
  searchFirstName,
  searchLastName,
  searchPhoneNumber,
  setUsers
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  var requestBody = {};
  if (searchEmail !== "") {
    requestBody["email"] = searchEmail;
  }
  if (searchFirstName !== "") {
    requestBody["first_name"] = searchFirstName;
  }
  if (searchLastName !== "") {
    requestBody["last_name"] = searchLastName;
  }
  if (searchPhoneNumber !== "") {
    requestBody["phone_number"] = searchPhoneNumber;
  }
  const response = await fetch(
    `${apiUrl}/admin/get_users?limit=${limit}&offset=${offset}`,
    {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(requestBody),
    }
  );
  const data = await response.json();
  setUsers(data.results);
};

export const fetchUserSubscriptions = async (
  userId,
  setUserSubscriptionIds
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_subscription?user_id=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const userSubscriptions = data.results;
    setUserSubscriptionIds(
      new Set(userSubscriptions.map((sub) => sub.subscription_id))
    );
  } catch (error) {
    console.error("Error fetching user subscriptions:", error);
  }
};

export const fetchSubscriptions = async (setSubscriptions) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  try {
    const response = await fetch(`${apiUrl}/admin/get_subscriptions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setSubscriptions(data.results.subscriptions_details);
  } catch (error) {
    console.error("Error fetching subscriptions:", error);
  }
};

export const subscribeUser = async (
  subscription,
  selectedUser,
  setShowSubscribeModal
) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const data = {
    reference_id: selectedUser.id,
    reference_type: "USER_ID",
    subscription_id: subscription.id,
    details_object: {},
    start_timestamp: new Date().toISOString(),
    subscription_status: "active",
  };

  const response = await fetch(`${apiUrl}/admin/user_subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });

  if (response.ok) {
    alert("User subscribed successfully");
    setShowSubscribeModal(false);
  } else {
    alert("Failed to subscribe user");
  }
};

export const fetchDashboards = async (setDashboards) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_dashboards`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setDashboards(
      data.results.dashboard_details.map((dashboard) => ({
        ...dashboard,
        details_object: JSON.stringify(dashboard.details_object),
      }))
    );
  } catch (error) {
    console.error("Error fetching dashboards:", error);
  }
};

export const fetchPackages = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(`${apiUrl}/admin/get_packages`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    return data.results.packages_details;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};
